import React from "react"
import {VariantProvider} from "./VariantContext"

// Gebruikt door gatsby-browser.js en gatsby-ssr.js: vult de context uit pageContext.
export const wrapPageElement = ({element, props}: any) => (
    <VariantProvider pageContext={props.pageContext}>{element}</VariantProvider>
)
